'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002419 from "./presto.-Agent-View$$anon$19.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$18() {
  this.awQ = null;
  this.awI = null;
  this.awJ = false;
  this.awR = null;
  this.awS = false;
  this.awV = null;
  this.awO = null;
  this.awP = false;
  this.awK = null;
  this.awL = false;
  this.awM = null;
  this.awN = false;
  this.awT = false;
  this.awU = false;
  this.awQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awV = "LocalPjeOfficeCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$18 as $c_Lpresto_AgentView$$anon$18 };
$p = $c_Lpresto_AgentView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$18;
/** @constructor */
function $h_Lpresto_AgentView$$anon$18() {
}
export { $h_Lpresto_AgentView$$anon$18 as $h_Lpresto_AgentView$$anon$18 };
$h_Lpresto_AgentView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.awQ;
});
$p.L = (function() {
  if ((!this.awJ)) {
    this.awI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awJ = true;
  }
  return this.awI;
});
$p.O = (function() {
  if ((!this.awS)) {
    this.awR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awS = true;
  }
  return this.awR;
});
$p.E = (function() {
  return this.awV;
});
$p.t = (function() {
  if ((!this.awP)) {
    this.awO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awP = true;
  }
  return this.awO;
});
$p.M = (function() {
  if ((!this.awL)) {
    this.awK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awL = true;
  }
  return this.awK;
});
$p.Q = (function() {
  if ((!this.awN)) {
    this.awM = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002419.$c_Lpresto_AgentView$$anon$19();
    this.awN = true;
  }
  return this.awM;
});
$p.w = (function() {
  if ((!this.awU)) {
    this.awT = false;
    this.awU = true;
  }
  return this.awT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee120) => ((p) => \u03b4scrutinee120.cFU(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$18, "presto.AgentView$$anon$18", ({
  DH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$18 as $d_Lpresto_AgentView$$anon$18 };
//# sourceMappingURL=presto.-Agent-View$$anon$18.js.map
